
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { LeafletMarkerOptions } from '../models/MachineMarkerLeafletOptions';
import * as L from 'leaflet';

/**
 * Add a marker to the leaflet map passed in and update position and icon when it changes
 */
@Component({ name: 'LeafletIconMarker' })
export default class LeafletIconMarker extends Vue {
  @Prop() map!: L.Map;
  @Prop() marker!: LeafletMarkerOptions;

  iconMarker = null as L.Marker | null;

  destroyed() {
    this.iconMarker?.remove();
  }

  mounted() {
    this.iconMarker = new L.Marker(this.marker.position, this.marker.MarkerOptions);
    this.iconMarker.setIcon(this.marker.MarkerOptions.icon as L.Icon);
    this.iconMarker.addTo(this.map);
  }

  @Watch('marker')
  onMarkerChange() {
    this.iconMarker?.addTo(this.map);
    this.iconMarker?.setLatLng(this.marker.position);
    this.iconMarker?.setIcon(this.marker.MarkerOptions.icon as L.Icon);
  }
}
